<template>
	<v-card elevation="0" class="ant-card pa-4">
		<v-card-title class="pa-0 d-flex align-center">
			<div class="v-typography--title1">{{ $t("description") }}</div>
			<v-spacer />
			<v-btn text outlined @click="onEdit">
				<v-icon size="15" left>icon-edit</v-icon>
				<span class="v-typography--body-sm">{{ $t("edit") }}</span>
			</v-btn>
		</v-card-title>
		<v-divider class="my-3" />
		<p class="v-typography--body-sm">
			{{ displayText }}
		</p>
	</v-card>
</template>

<script>
export default {
	name: "ProductDescription",
	props: {
		description: {
			type: Object,
			default: () => ({}),
		},
		lang: {
			type: String,
			required: true,
		},
	},
	computed: {
		displayText() {
			const d = this.description || {};
			const l = this.lang || "en";
			const v =
				(typeof d.get === "function" ? d.get(l) : d[l]) ||
				(typeof d.get === "function" ? d.get("_default") : d._default);
			return (v && String(v).trim()) || "-";
		},
	},
	methods: {
		onEdit() {
			this.$emit("edit");
		},
	},
};
</script>
